import { createElement } from "react";
import type { ZudokuPlugin } from "zudoku";

export const ARD_PATH = "/.well-known/ard.json";
export const API_CATALOG_PATH = "/.well-known/api-catalog";
export const API_CATALOG_MEDIA_TYPE =
  'application/linkset+json; profile="https://www.rfc-editor.org/info/rfc9727"';

/**
 * Advertises the origin-level discovery documents generated by the companion
 * build step. API and MCP metadata are derived from normal Zudoku and OpenAPI
 * configuration, so the plugin intentionally has no options.
 */
export const agenticPlugin = (): ZudokuPlugin => ({
  getHead: () => [
    createElement("link", {
      key: "agentic-resource-discovery",
      rel: "ard",
      href: ARD_PATH,
      type: "application/json",
    }),
    createElement("link", {
      key: "api-catalog-discovery",
      rel: "api-catalog",
      href: API_CATALOG_PATH,
      type: API_CATALOG_MEDIA_TYPE,
    }),
  ],
});
